import axios from "axios";
import Vue from "vue";
let sessionId = window.name;
export default {
  state: () => ({
    alertText: "",
    alertTitle: "",
    dismissCountDown: 0,
    dismissSecs: 0,
    alertVariant: "",
    alertIcon: "",
    isLoading: true,
    isHistoryLoading: true,
    warningModalContent: null,
    lastOpenedSideBarContent: null,
    // idleTimeout:null,
    idleTimeInMinutes: 10,
    lastActivityTime: new Date(),
    staffNotifications: [],
    // Bu oturumda (tam sayfa reload'a kadar) ekranda gösterilmiş bilgilendirme id'leri.
    // EVERY_LOGIN/ONCE'ın her poll'de tekrar açılmasını engeller. Login/logout tam reload
    // yaptığından bu liste yeni oturumda otomatik temizlenir.
    shownStaffNotificationIds: [],
  }),

  mutations: {
    setAlertText(state, alertText) {
      Vue.set(state, "alertText", alertText);
    },
    setAlertTitle(state, alertTitle) {
      Vue.set(state, "alertTitle", alertTitle);
    },
    setDismissCountDown(state, dismissCountDown) {
      Vue.set(state, "dismissCountDown", dismissCountDown);
    },
    setAlertVariant(state, alertVariant) {
      Vue.set(state, "alertVariant", alertVariant);
    },
    setDismissSecs(state, dismissSecs) {
      Vue.set(state, "dismissSecs", dismissSecs);
    },
    setAlertIcon(state, alertIcon) {
      Vue.set(state, "alertIcon", alertIcon);
    },
    setIsLoading(state, isLoading) {
      Vue.set(state, "isLoading", isLoading);
    },
    setWarningModalContent(state, warningModalContent) {
      Vue.set(state, "warningModalContent", warningModalContent);
    },
    setLastOpenedSideBarContent(state, lastOpenedSideBarContent) {
      Vue.set(state, "lastOpenedSideBarContent", lastOpenedSideBarContent);
    },
    setIdleTimeInMinutes(state, idleTimeInMinutes) {
      Vue.set(state, "idleTimeInMinutes", idleTimeInMinutes);
    },
    setLastActivityTime(state, lastActivityTime) {
      Vue.set(state, "lastActivityTime", lastActivityTime);
    },
    setDefaultHelperModule(state) {
      Vue.set(state, "alertText", "");
      Vue.set(state, "alertTitle", "");
      Vue.set(state, "dismissCountDown", 0);
      Vue.set(state, "dismissSecs", 0);
      Vue.set(state, "alertVariant", "");
      Vue.set(state, "alertIcon", "");
      Vue.set(state, "isLoading", true);
      Vue.set(state, "isHistoryLoading", true);
      Vue.set(state, "warningModalContent", null);
      Vue.set(state, "lastOpenedSideBarContent", false);
      Vue.set(state, "idleTimeInMinutes", 10);
      Vue.set(state, "lastActivityTime", new Date());
    },
    setStaffNotifications(state, notifications) {
      Vue.set(state, "staffNotifications", notifications);
    },
    addShownStaffNotificationId(state, id) {
      if (!state.shownStaffNotificationIds.includes(id)) {
        state.shownStaffNotificationIds.push(id);
      }
    },
    resetShownStaffNotifications(state) {
      Vue.set(state, "shownStaffNotificationIds", []);
    },
  },

  actions: {
    getPdf: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/pdf/getPdf", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getMultiplePdf: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/pdf/getMultiplePdf", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getSlipBiletPdf: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/pdf/handterminal-ticket", request, {})
        .then((response) => response.data)
        .catch((err) => err.response);
    },
    getGeneratePdf: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/pdf/generatePdf", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getGeneratePdfAll: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/pdf/generate-pdf", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    prnGenerateBoardingPass: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/prn/generate-boarding-pass/download", request, {
          responseType: "arraybuffer",
        })
        .then((response) => response.data)
        .catch((err) => err.response);
    },
    // Fatura butonunun açılıp açılmayacağı bilet bazında buradan öğreniliyor: mali e-bileti
    // olmayan bilette PDF isteği hiç atılmadan kullanıcıya sebep gösteriliyor.
    getEbiletAvailability: (context, ticketNumbers) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pdf/ebilet/tickets/availability", {
          params: { ticketNumbers: Array.isArray(ticketNumbers) ? ticketNumbers.join(",") : ticketNumbers },
        })
        .then((response) => response.data);
    },
    getEbiletInvoicePdf: (context, ticketNumbers) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pdf/ebilet/tickets", {
          params: { ticketNumbers: Array.isArray(ticketNumbers) ? ticketNumbers.join(",") : ticketNumbers },
          responseType: "arraybuffer",
        })
        .then((response) => response);
      // Hata bilinçli olarak yutulmuyor: err.response döndürüldüğünde çağıran taraf onu PDF
      // gövdesi sanıp servisin gerçek mesajını kaybediyordu.
    },
    getNotifications(context) {
      return axios.get(context.getters.getMcServiceUrl + "/notifications", {}).then((response) => {
        return response.data;
      });
    },
    putNotification(context, request) {
      return axios.put(context.getters.getMcServiceUrl + "/notifications/user-notification/read/" + request.id).then((response) => {
        return response.data;
      });
    },
    deleteUserNotification(context, request) {
      return axios.put(context.getters.getMcServiceUrl + "/notifications/user-notification/delete/" + request.id).then((response) => {
        return response.data;
      });
    },
    sendMail(context, request) {
      return axios.post(context.getters.getPoolExternalUrl + "/pex/notifications/send-email", request).then((response) => {
        return response.data;
      });
    },
    sendSms(context, request) {
      return axios.post(context.getters.getCrsServiceUrl + "/notifications/send-for-ticket", request).then((response) => {
        return response;
      });
    },
    servisCheck(context) {
      return axios.get(context.getters.getMcServiceUrl + "/servise-checks", {}).then((response) => {
        return response;
      });
    },
    loadEvaluations(context) {
      return axios.get(context.getters.getTmsServiceUrl + "/evaluations", {}).then((response) => {
        return response.data;
      });
    },
    readEvaluations(context, request) {
      return axios.get(context.getters.getTmsServiceUrl + "/evaluations/read-and-return/" + request, {}).then((response) => {
        return response.data;
      });
    },
    getPriceExchangeWithMultiplier(context) {
      return axios.get(context.getters.getPoolExternalUrl + "/pex/price/exchange-with-multiplier").then((response) => {
        return response.data;
      });
    },
    fetchStaffNotifications(context) {
      const unitId = context.getters.getSelectedUserUnitId;
      if (!unitId) return Promise.resolve([]);
      return axios
        .get(context.getters.getMcServiceUrl + "/staff-notifications/pending", {
          params: { environment: "dev" },
          headers: { "unit-id": unitId },
        })
        .then((response) => {
          context.commit("setStaffNotifications", response.data || []);
          return response.data;
        })
        .catch(() => {
          return [];
        });
    },
    confirmStaffNotification(context, informationId) {
      const unitId = context.getters.getSelectedUserUnitId;
      return axios
        .post(context.getters.getMcServiceUrl + "/staff-notifications/confirm/" + informationId, null, {
          params: { environment: "dev" },
          headers: { "unit-id": unitId },
        })
        .then((response) => response.data);
    },
    markStaffNotificationShown(context, informationId) {
      const unitId = context.getters.getSelectedUserUnitId;
      return axios
        .post(context.getters.getMcServiceUrl + "/staff-notifications/shown/" + informationId, null, {
          params: { environment: "dev" },
          headers: { "unit-id": unitId },
        })
        .then((response) => response.data);
    },
    closeStaffNotification(context, informationId) {
      const unitId = context.getters.getSelectedUserUnitId;
      return axios
        .post(context.getters.getMcServiceUrl + "/staff-notifications/close/" + informationId, null, {
          params: { environment: "dev" },
          headers: { "unit-id": unitId },
        })
        .then((response) => response.data);
    },
    logStaffNotificationDownload(context, { informationId, attachmentId }) {
      const unitId = context.getters.getSelectedUserUnitId;
      const params = { environment: "dev" };
      if (attachmentId) {
        params.attachmentId = attachmentId;
      }
      return axios
        .post(context.getters.getMcServiceUrl + "/staff-notifications/download/" + informationId, null, {
          params: { environment: "dev" },
          headers: { "unit-id": unitId },
        })
        .then((response) => response.data);
    },
    fetchStaffNotificationHistory(context) {
      const unitId = context.getters.getSelectedUserUnitId;
      if (!unitId) return Promise.resolve([]);
      return axios
        .get(context.getters.getMcServiceUrl + "/staff-notifications/history", {
          params: { environment: "dev" },
          headers: { "unit-id": unitId },
        })
        .then((response) => response.data || [])
        .catch(() => []);
    },
    loadInformationInteractionLogs(context, { informationId, enrollmentNo, firstName, lastName, page, size }) {
      const params = {
        environment: "dev",
        page: page || 0,
        size: size || 20,
      };
      if (enrollmentNo) params.enrollmentNo = enrollmentNo;
      if (firstName) params.firstName = firstName;
      if (lastName) params.lastName = lastName;
      return axios
        .get(context.getters.getMcServiceUrl + "/information-management/" + informationId + "/interaction-logs", { params })
        .then((response) => response.data)
        .catch(() => ({ content: [], totalElements: 0 }));
    },
  },
  getters: {
    getAlertName: (state) => {
      return state.alertName;
    },
    getAlertText: (state) => {
      return state.alertText;
    },
    getAlertTitle: (state) => {
      return state.alertTitle;
    },
    getDismissCountDown: (state) => {
      return state.dismissCountDown;
    },
    getAlertVariant: (state) => {
      return state.alertVariant;
    },
    getDismissSecs: (state) => {
      return state.dismissSecs;
    },
    getAlertIcon: (state) => {
      return state.alertIcon;
    },
    getIsLoading: (state) => {
      return state.isLoading;
    },
    getIsHistoryLoading: (state) => {
      return state.isHistoryLoading;
    },
    getWarningModalContent: (state) => {
      return state.warningModalContent;
    },
    getLastOpenedSideBarContent: (state) => {
      return state.lastOpenedSideBarContent;
    },
    // getIdleTimeout: state=>{
    //     return state.idleTimeout;
    // },
    getIdleTimeInMinutes: (state) => {
      return state.idleTimeInMinutes;
    },
    getLastActivityTime: (state) => {
      return state.lastActivityTime;
    },
    getStaffNotifications: (state) => {
      return state.staffNotifications;
    },
    getShownStaffNotificationIds: (state) => {
      return state.shownStaffNotificationIds;
    },
    getReportId: (state) => (slug) => state.reportMap[slug],
  },
};
